export default __webpack_public_path__ + "static/double_door_w.4cb110b5973ebbeb366477330c4bad9a.png";